import { create } from 'zustand'

type InitialLinkingState = {
  url?: URL
  redirectUri?: string
  skipOnboarding?: string
}

type DisposeType = keyof InitialLinkingState

type InitialLinkingActions = {
  add: (v: string) => void
  dispose: (type: DisposeType | 'all') => void
}

const initialState: InitialLinkingState = {
  url: undefined,
  redirectUri: undefined,
  skipOnboarding: undefined
}
export const useInitialLinkingStore = create<InitialLinkingState & InitialLinkingActions>((set, get) => ({
  ...initialState,
  add: (value: string) => {
    const newUrl = new URL(value)
    return set(() => ({
      url: newUrl,
      redirectUri: newUrl.searchParams.get('redirectUri') ?? undefined,
      skipOnboarding: newUrl.searchParams.get('skipOnboarding') ?? undefined
    }))
  },
  dispose: (type) => {
    switch (type) {
      case 'url':
        return set(() => ({ url: undefined }))
      case 'redirectUri':
        return set(() => ({ redirectUri: undefined }))
      case 'skipOnboarding':
        return set(() => ({ skipOnboarding: undefined }))
      case 'all':
        return set(() => initialState)
    }
  }
}))
